import { ImageTemplates } from "~/components/image/types";
import { WindowFormat } from "~/context/breakpoints/types";

export const imageTemplates: ImageTemplates = {
  [WindowFormat.mobile]: "productimages-mobile",
  [WindowFormat.tablet]: "productimages-tablet",
  [WindowFormat.desktop]: "productimages-regulardesktop",
  [WindowFormat.wideDesktop]: "productimages-largedesktop",
};

const PRODUCT_CARD_CLASSES_PREFIX = "ProductCard";
const REMOVED_PRODUCT_CARD_CLASSES_PREFIX = "ProductCardRemoved";

export const PRODUCT_CARD_CLASSES = {
  root: `${PRODUCT_CARD_CLASSES_PREFIX}-root`,
  imageWrapper: `${PRODUCT_CARD_CLASSES_PREFIX}-imageWrapper`,
  unpublishedProduct: `${PRODUCT_CARD_CLASSES_PREFIX}-unpublishedProduct`,
  image: `${PRODUCT_CARD_CLASSES_PREFIX}-image`,
  tags: `${PRODUCT_CARD_CLASSES_PREFIX}-tags`,
  comingSoonTag: `${PRODUCT_CARD_CLASSES_PREFIX}-comingSoonTag`,
  description: `${PRODUCT_CARD_CLASSES_PREFIX}-description`,
  title: `${PRODUCT_CARD_CLASSES_PREFIX}-title`,
  price: `${PRODUCT_CARD_CLASSES_PREFIX}-price`,
  priceLink: `${PRODUCT_CARD_CLASSES_PREFIX}-priceLink`,
  pricePerUnitText: `${PRODUCT_CARD_CLASSES_PREFIX}-pricePerUnitText`,
  colors: `${PRODUCT_CARD_CLASSES_PREFIX}-colors`,
  iconsGroup: `${PRODUCT_CARD_CLASSES_PREFIX}-iconsGroup`,
  shoppingIconsGroup: `${PRODUCT_CARD_CLASSES_PREFIX}-shoppingIconsGroup`,
  shoppingListProductStatus: `${PRODUCT_CARD_CLASSES_PREFIX}-shoppingListProductStatus`,
  statusIcon: `${PRODUCT_CARD_CLASSES_PREFIX}-statusIcon`,
  shoppingListProductColor: `${PRODUCT_CARD_CLASSES_PREFIX}-shoppingListProductColor`,
  labelRow: `${PRODUCT_CARD_CLASSES_PREFIX}-labelRow`,
  oneSizeLabel: `${PRODUCT_CARD_CLASSES_PREFIX}-oneSizeLabel`,
  sizeBox: `${PRODUCT_CARD_CLASSES_PREFIX}-sizeBox`,
  block: `${PRODUCT_CARD_CLASSES_PREFIX}-block`,
  addToBag: `${PRODUCT_CARD_CLASSES_PREFIX}-addToBag`,
  maxQuantityError: `${PRODUCT_CARD_CLASSES_PREFIX}-maxQuantityError`,
};

export const REMOVED_PRODUCT_CARD_CLASSES = {
  removedProduct: `${REMOVED_PRODUCT_CARD_CLASSES_PREFIX}-removedProduct`,
  removedProductImage: `${PRODUCT_CARD_CLASSES_PREFIX}-removedProductImage`,
  removedProductDescription: `${REMOVED_PRODUCT_CARD_CLASSES_PREFIX}-removedProductDescription`,
  removedProductName: `${REMOVED_PRODUCT_CARD_CLASSES_PREFIX}-removedProductName`,
  undoButton: `${REMOVED_PRODUCT_CARD_CLASSES_PREFIX}-undoButton`,
};
